import { render } from "./EgyptianReferences.vue?vue&type=template&id=35ba9664"
import script from "./EgyptianReferences.vue?vue&type=script&lang=js"
export * from "./EgyptianReferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__